import { BackgroundStyle } from './Avatar.theme.utils';
export var avatarTheme = {
  baseStyle: _ref => {
    var {
      onClick,
      isDisabled,
      bgColor
    } = _ref;
    return {
      container: {
        display: 'inline-flex',
        position: 'relative',
        width: 'fit-content',
        height: 'fit-content'
      },
      avatar: {
        overflow: 'hidden',
        display: 'inline-flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        border: 'basic.light',
        width: '100%',
        height: 'auto',
        backgroundColor: BackgroundStyle[bgColor !== null && bgColor !== void 0 ? bgColor : 'default'],
        color: bgColor === 'avatar6' ? 'neutral.white' : 'neutral.black',
        userSelect: 'none',
        _after: {
          content: "''",
          width: '100%',
          height: '100%',
          backgroundColor: 'neutral.black',
          opacity: '0',
          position: 'absolute',
          top: '0px',
          left: '0px',
          transition: 'opacity 0.3s ease'
        },
        _hover: {
          _after: {
            opacity: onClick && !isDisabled ? '0.35' : '0'
          }
        },
        _disabled: {
          backgroundColor: 'neutral.light',
          color: 'neutral.white',
          cursor: 'not-allowed'
        },
        _selected: {
          outline: '2px solid',
          outlineColor: 'brand.main',
          outlineOffset: '2px'
        }
      },
      image: {
        // So the image and the initials won't co-exist side-by-side for the flicker of time
        position: 'absolute'
      },
      initials: {},
      badge: {
        display: 'inline-flex',
        borderRadius: 'full',
        border: '2px solid #fff',
        position: 'absolute',
        bottom: '-2px',
        right: '-2px',
        backgroundColor: 'neutral.white',
        zIndex: 1,
        overflow: 'hidden'
      }
    };
  },
  variants: {
    circle: {
      avatar: {
        borderRadius: 'full',
        _after: {
          borderRadius: 'full'
        }
      }
    },
    square: {
      avatar: {
        borderRadius: 'm',
        _after: {
          borderRadius: 'm'
        }
      }
    }
  },
  sizes: {
    'extra-small': {
      avatar: {
        width: '16px',
        height: '16px'
      },
      initials: {
        textStyle: 'caption1Semi'
      }
    },
    small: {
      avatar: {
        w: '24px',
        h: '24px'
      },
      initials: {
        textStyle: 'caption1Semi'
      },
      badge: {
        bottom: '-4px',
        right: '-4px'
      }
    },
    medium: {
      avatar: {
        w: '40px',
        h: '40px'
      },
      initials: {
        textStyle: 'body4Semi'
      }
    },
    large: {
      avatar: {
        w: '56px',
        h: '56px'
      },
      initials: {
        textStyle: 'body2Semi'
      }
    },
    'extra-large': {
      avatar: {
        w: '120px',
        h: '120px'
      },
      initials: {
        textStyle: 'body1Semi'
      }
    }
  },
  defaultProps: {
    size: 'medium',
    variant: 'circle'
  }
};
//# sourceMappingURL=Avatar.theme.js.map